import React, { useEffect } from 'react'
import TablaCamionesRechazadosEnBrutoView from '../components/TablaCamionesRechazadosEnBrutoView'
import { actualizarDatos } from '../actions/TablaCamionesRechazadosEnBrutoActions'
import { connect } from 'react-redux'

function TablaCamionesRechazadosEnBruto (props) {
  const { actualizarDatos } = props

  useEffect(() => {
    actualizarDatos()
  }, [actualizarDatos])

  return (
    <TablaCamionesRechazadosEnBrutoView />
  )
}

const mapActionsToProps = {
  actualizarDatos
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaCamionesRechazadosEnBruto)
